import styled from 'styled-components'

export const DropdownWrapper = styled.span`
  position: relative;
  display: inline-block;
  vertical-align: baseline;
  margin: 0 2px;
`
